import styled from "styled-components";

export const Overlay = styled.div`
  background: rgba(0, 0, 0, 0.25);
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  backdrop-filter: blur(20px);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FilterModalContainer = styled.div`
  background: ${({ theme }) => theme.console.referrals.modalBackgroundColor};
  border: 1px solid ${({ theme }) => theme?.console.referrals.modalBorderColor};
  border-radius: 4px;
  box-shadow: 0px 0px 32px 0px rgba(0, 0, 0, 0.08);

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: absolute;
  z-index: 15;

  padding: 1rem 0;
  max-width: 35.625rem; //570px
  width: 100%;
  max-height: 48.813rem;
  height: -webkit-fill-available;
  margin: 1rem;

  @media (max-width: 700px) {
    width: -webkit-fill-available;
    top: 0;
  }

  animation: appear 0.4s normal;

  @keyframes appear {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  .top-section {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 0 1.5rem 0.75rem;
    border-bottom: 1px solid
      ${({ theme }) => theme?.console?.referrals.modalBorderColor};

    h3 {
      color: ${({ theme }) => theme.groups.primaryText} !important;
      font: 500 1rem/1.5rem "Inter";
      margin: 0;
    }

    .close-icon {
      cursor: pointer;
    }
  }

  .buttons-section {
    display: flex;
    justify-content: flex-end;
    gap: 0.625rem;
    width: 100%;
    padding: 0.75rem 1.5rem 0;
    border-top: 1px solid
      ${({ theme }) => theme?.console?.referrals.modalBorderColor};

    @media (max-width: 500px) {
      button {
        width: 100%;
      }
    }
  }
`;

export const FiltersSection = styled.div`
  width: 100%;
  padding: 0.75rem 1.5rem;
  display: flex;
  flex-direction: column;

  max-height: 42.313rem;
  height: 100%;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 4px;
    display: block;
  }
  &::-webkit-scrollbar-track {
    width: 4px;
    display: block;
  }
  &::-webkit-scrollbar-thumb {
    width: 4px;
    display: block;
  }

  .tag-section {
    &::-webkit-scrollbar {
      width: 4px;
      display: block;
    }

    &::-webkit-scrollbar-track {
      width: 4px;
      display: block;
    }

    &::-webkit-scrollbar-thumb {
      width: 4px;
      display: block;
    }
  }
`;
